import React from 'react';
interface HighlightQuoteProps {
  children: React.ReactNode;
  className?: string;
  size?: 'md' | 'lg';
}
export function HighlightQuote({
  children,
  className = '',
  size = 'md'
}: HighlightQuoteProps) {
  const text = size === 'lg' ? 'text-3xl sm:text-4xl lg:text-5xl' : 'text-2xl sm:text-3xl lg:text-4xl';
  return <blockquote className={`border-l-4 border-brand pl-5 sm:pl-7 ${className}`} data-id="element-284" data-mp="3tr8oo0dhd3mu">
      <p className={`max-w-4xl font-display font-bold uppercase leading-[1.05] text-white ${text}`} data-id="element-285" data-mp="la5jfmy6rwbt">{children}</p>
    </blockquote>;
}